import { DateTime } from 'luxon';
import { ObjectState } from '../../enums/objectState.enum';
import { AccessRule } from '../../interfaces/auth/access-rule';
import { IConfigObjectBase } from '../../interfaces/config-objects/config-object-base';
import { Guid } from '../guid';
import { MFAConfig } from './mfa-config';

export class UserConfig implements IConfigObjectBase {
	id = Guid();
	name = '';
	description?: string;
	dateCreated = DateTime.now();
	lastUpdated = DateTime.now();
	objectState?: ObjectState;

	surname?: string;
	email = '';
	password? = '';
	passwordExpired?: boolean;
	roles: string[] = [];
	locked = false;
	isAdmin?: boolean;
	isSystemUser?: boolean;
	mfaConfig?: MFAConfig;

	defaultTenantID?: string;
	userPermissions?: AccessRule[];

	constructor(init?: Partial<UserConfig>) {
		if (init) {
			Object.assign(this, init);
		}
	}
}
